export const initialState = {
  actual: [],
  notificationsOld: [],
  notificationsCur: [],
  notifications: [],
  soundTrigger: {},
  // iteration: 1,
};
